import React from 'react';
import { FilterIcon } from 'lucide-react';
interface StatusFilterProps {
  selected: string;
  onChange: (status: string) => void;
}
export const StatusFilter = ({
  selected,
  onChange
}: StatusFilterProps) => {
  const options = [{
    value: 'all',
    label: 'All Orders',
    count: 28764
  }, {
    value: 'needs-action',
    label: 'Needs Action',
    count: 156
  }, {
    value: 'returned',
    label: 'Returned',
    count: 23
  }];
  return <div className="relative" data-id="element-821">
      <select value={selected} onChange={e => onChange(e.target.value)} className="appearance-none pl-8 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-822">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-823">
            {option.label} ({option.count})
          </option>)}
      </select>
      <FilterIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" data-id="element-824" />
    </div>;
};